import { resolveSuperAdminUser } from 'utils/company/resolveSuperAdminUser';
import type { HeaderSettingsAlertCheck, HeaderSettingsAlertIssue } from 'utils/headerSettingsAlert/types';

export const ACCOUNT_ABOUT_FIX_PATH = '/account/about';

export const missingSuperAdminCheck: HeaderSettingsAlertCheck = {
  id: 'missing-super-admin',
  run(ctx): HeaderSettingsAlertIssue[] {
    const admin = resolveSuperAdminUser(ctx.company?.SuperAdmin, ctx.applicationUsers);
    if (admin) return [];

    return [
      {
        id: 'missing-super-admin',
        messagePath: 'header.settingsAlert.summary.missingSuperAdmin',
        fixPath: ACCOUNT_ABOUT_FIX_PATH,
        fixTargetKey: 'accountAbout',
      },
    ];
  },
};
